export default __webpack_public_path__ + "static/media/Information_Icon.9544dbb2.svg";